export default {
  addEvent: (context, payload) => {
    context.commit('addEvent', payload)
  },
}
